import { Entity } from '@goodboydigital/odie';
import type { Container, Transform } from 'pixi.js';

import { Scene25D } from './Scene25D';
import { View25DComponent, View25DComponentOptions } from './View25DComponent';

export class Entity25D<D = View25DComponentOptions> extends Entity<D, Scene25D>
{
    public transform: Transform;
    public view25d: View25DComponent;
    protected _x: number;
    protected _y: number;
    protected _z: number;

    constructor(view25dData: View25DComponentOptions = {})
    {
        super();

        this.view25d = this.addComponent(View25DComponent, view25dData);
        this.transform = this.view.transform;
        this._x = 0;
        this._y = 0;
        this._z = 0;
    }

    get view(): Container
    {
        return this.view25d.view;
    }

    get x(): number
    {
        return this._x;
    }

    set x(value: number)
    {
        this._x = value;
    }

    get y(): number
    {
        return this._y;
    }

    set y(value: number)
    {
        this._y = value;
    }

    get z(): number
    {
        return this._z;
    }

    set z(value: number)
    {
        this._z = value;
    }

    set scaleX(value: number)
    {
        this.transform.scale.x = value;
    }

    get scaleX(): number
    {
        return this.transform.scale.x;
    }

    set scaleY(value: number)
    {
        this.transform.scale.y = value;
    }

    get scaleY(): number
    {
        return this.transform.scale.x;
    }

    get rotation(): number
    {
        return this.view.rotation;
    }

    set rotation(value: number)
    {
        this.view.rotation = value;
    }
}
